import ColumnChart from "../charts/columnChart";
import DonutChart from "../charts/donutChart";
import { useState } from "react";
import useStore from "../../hooks/useStore";
import { observer } from "mobx-react";
import { Form } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import EnergyAccordion from "./energyAccordion";
import ShowPerformance from "../showPerformance";
import { getRoundedValue } from "../../utils/helpers";
import CustomSpinner from "../spinner/Spinner";

function DashboardEnergy({ year }) {
  const {
    dashboardStore: { dashboardDetails },
  } = useStore();
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("KWh");

  // Conversion logic
  const convertValue = (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value;
    if (fromUnit === "KWh" && toUnit === "Gj") return value * 0.0036;
    if (fromUnit === "KWh" && toUnit === "Mj") return value / 0.277778;
    if (fromUnit === "KWh" && toUnit === "J") return value * 3600000;
    return value;
  };

  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  return (
    <div className="row h-100">
      <div className="col-xl-12">
        <div className="card h-100 dashboard-card ">
          <div className="card-body">
            <div className="d-flex flex-wrap align-items-start">
              <h5 className="mb-3 text-muted"> Energy Report</h5>
              <div className="ms-auto">
                <Form.Select
                  value={selectedUnit}
                  onChange={e => setSelectedUnit(e.target.value)}
                  className="w-auto px-3 py-2 rounded"
                  style={{ minWidth: "100px", fontWeight: "500" }}
                >
                  <option value="KWh">KWh</option>
                  <option value="Gj">Gj</option>
                  <option value="Mj">Mj</option>
                  <option value="J">J</option>
                </Form.Select>
              </div>
            </div>
            {dashboardDetails?.charts ? (
              <ColumnChart
                categories={[`CY${year}`, `CY${year-1}`]}
                unit={selectedUnit}
                data={
                  dashboardDetails?.charts?.energy?.columnChart?.map((series) => ({
                    ...series,
                    data: [...series.data].reverse().map(v => convertValue(v, "KWh", selectedUnit)),
                  }))
                }
                yaxis={[]}
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-75">
                <CustomSpinner />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="col-xl-12 h-100 mt-4">
        {/* achievements and target  */}

        <div className="row">
          <div className="col-md-6 mb-4">
            <ShowPerformance label="energy" />
          </div>

          {/* donut chart  */}
          <div className="col-md-6 mb-4">
            <div className="card mb-0 h-100 dashboard-donut-card">
              <div className="card-body">
                <div className="d-flex flex-wrap align-items-start">
                  <h5 className="mb-3 text-muted donut-heading">
                    Energy Generated by Sources
                  </h5>
                  <div className="ms-auto">
                    <div className="toolbar d-flex flex-wrap gap-2 ">
                      <div className="">
                        <p className="text-muted mb-1">Unit</p>
                        <h6 className="unit-value">
                          {selectedUnit}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                {dashboardDetails?.charts ? (
                  <div className="donut">
                    <DonutChart
                      data={
                        dashboardDetails?.charts?.energy?.doughnutChart.map(
                          (ele) => getRoundedValue(convertValue(ele.value, "KWh", selectedUnit))
                        ) || []
                      }
                      labels={
                        dashboardDetails?.charts?.energy?.doughnutChart.map(
                          (ele) => ele.label
                        ) || []
                      }
                      unit={selectedUnit}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-75">
                    <CustomSpinner />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accordion
        className="dashboard-chart-accordion"
        onSelect={handleAccordionToggle}
      >
        <Accordion.Item key={`energy-accordian`} eventKey={0}>
          <Accordion.Header>
            {isAccordionOpen ? "See less" : "See more"}
          </Accordion.Header>
          <Accordion.Body>
            <EnergyAccordion year={year} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default observer(DashboardEnergy);
